import React from "react";
import { Button, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import NoData from "../../pagecomponents/Common/NoData";
import Loader from "../../pagecomponents/Common/Loader";
import { checkEmpty } from "../../../src/helpers/utility";
import Swal from "sweetalert2";

const JobReport = ({
  columns,
  data,
  onEdit,
  onDelete,
  onSorting,
  sortingState,
  currentPage,
  totalPages,
  rowsPerPage,
  updateRowsPerPage,
  onPageChange,
  loader,
}) => {
  const getSortingIcon = (key) => {
    if (sortingState?.key === key) {
      return sortingState.order === "asc" ? (
        <i className="fa fa-caret-up"></i>
      ) : (
        <i className="fa fa-caret-down"></i>
      );
    }
    return (
      <i
        className="fas fa-exchange-alt"
        style={{ transform: "rotate(90deg)" }}
      ></i>
    );
  };

  const deleteConfirmation = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(item.job_Id);
      }
    });
  };

  return (
    <>
      {loader && <Loader />}

      {!loader && !checkEmpty(data) && (
        <>
          {/* Rows Per Page Dropdown */}
          <div className="d-flex">
            <label htmlFor="showRowsPerPage">Show</label>
            <select
              className=" mb-4 selectpage border me-1"
              id="showRowsPerPage"
              value={rowsPerPage}
              onChange={(e) => updateRowsPerPage(Number(e.target.value))}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>

          {/* Report Table */}
          <div className="table-responsive">
            <Table className="table table-bordered text-nowrap mb-0">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th
                      key={column.accessor}
                      onClick={
                        column.sortable
                          ? () => onSorting(column.accessor)
                          : undefined
                      }
                      className={`cursor-pointer ${
                        column.sortable ? "text-blue-500" : "text-gray-500"
                      }`}
                    >
                      {column.label}{" "}
                      {column.sortable && (
                        <span>{getSortingIcon(column.accessor)}</span>
                      )}
                    </th>
                  ))}
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={index}>
                    {columns.map((column) => (
                      <td key={column.accessor}>
                        {(() => {
                          if (column.accessor === "index") {
                            return (currentPage - 1) * rowsPerPage + index + 1;
                          } else if (column.accessor === "job_Date") {
                            return item[column.accessor].split(" ")[0];
                          } else if (column.accessor === "invoice_Id") {
                            if (item[column.accessor] === 0) {
                              return (
                                <span className="badge badge-danger">
                                  Pending
                                </span>
                              );
                            } else {
                              return (
                                <span className="badge badge-success">
                                  Done
                                </span>
                              );
                            }
                          } else if (
                            column.accessor === "rate" ||
                            column.accessor === "jobChargeTotalAmount"
                          ) {
                            return (
                              item.job_currency_Code +
                              " " +
                              item[column.accessor]
                            );
                          } else {
                            return item[column.accessor];
                          }
                        })()}
                      </td>
                    ))}
                    <td className="text-center">
                      {(
                        <span className="">
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Edit</Tooltip>}
                          >
                            <Link
                              to="#"
                              onClick={() => {
                                onEdit(item);
                              }}
                              className="btn btn-primary btn-sm rounded-11 me-2"
                            >
                              <i>
                                <svg
                                  className="table-edit"
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  width="16"
                                >
                                  <path d="M0 0h24v24H0V0z" fill="none" />
                                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                                </svg>
                              </i>
                            </Link>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Delete</Tooltip>}
                          >
                            <Link
                              to="#"
                              onClick={() => {
                                deleteConfirmation(item);
                              }}
                              className="btn btn-danger btn-sm rounded-11"
                            >
                              <i>
                                <svg
                                  className="table-delete"
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  width="16"
                                >
                                  <path d="M0 0h24v24H0V0z" fill="none" />
                                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                                </svg>
                              </i>
                            </Link>
                          </OverlayTrigger>
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="d-block d-sm-flex mt-4 ">
              <span className="">
                Page{" "}
                <strong>
                  {currentPage} of {totalPages}
                </strong>{" "}
              </span>
              <span className="ms-sm-auto ">
                <Button
                  variant=""
                  className="btn-default tablebutton me-2 my-1"
                  onClick={() => {
                    onPageChange(1);
                  }}
                  disabled={currentPage === 1}
                >
                  {" << "}
                </Button>
                <Button
                  variant=""
                  className="btn-default tablebutton me-2 d-sm-inline d-block my-1"
                  onClick={() => onPageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  {" Previous "}
                </Button>
                <Button
                  variant=""
                  className="btn-default tablebutton me-2 d-sm-inline d-block my-1"
                  onClick={() => {
                    onPageChange(currentPage + 1);
                  }}
                  disabled={currentPage === totalPages}
                >
                  {" Next "}
                </Button>
                <Button
                  variant=""
                  className="btn-default tablebutton me-2 my-1"
                  onClick={() => {
                    onPageChange(totalPages);
                  }}
                  disabled={currentPage === totalPages}
                >
                  {" >> "}
                </Button>
              </span>
            </div>
          )}
        </>
      )}

      {!loader && checkEmpty(data) && <NoData />}
    </>
  );
};

export default JobReport;
